module.exports = __webpack_public_path__ + "static/credits-img-304c462ce3d0219fce30e2dd671a8ff1.jpg";